import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6c3c2a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex gap-2 flex-row flex-wrap card-container blue-container text-sm" }
const _hoisted_2 = {
  key: 0,
  class: "align-items-center justify-content-center"
}
const _hoisted_3 = {
  key: 1,
  class: "align-items-center justify-content-center font-bold text-lg"
}
const _hoisted_4 = {
  key: 2,
  class: "align-items-center justify-content-center text-sm"
}
const _hoisted_5 = {
  key: 3,
  class: "align-items-center justify-content-center text-sm"
}

import {UserInfo, useUserInfo} from "@/stores/InfoStore";
import {formatWorkTime} from "@/services/FormatService";
import {computed, inject} from "vue";
import moment from "moment";
import {useRouter} from "vue-router";
import {useUserStore} from "@/stores/UserStore";
import {AxiosStatic} from "axios";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  setup(__props) {


const router = useRouter()
const userInfo = useUserInfo()

const userStore = useUserStore()

// Define computed
const month = computed(() => {
  const mf = moment(userInfo.userInfo.fromTime)
  const mt = moment(userInfo.userInfo.toTime)
  return mf.format("MMMM YYYY")
})

const earning = computed(() => {
  return Math.round(userInfo.allEarningSum) + " Kč"
})

const axios = inject<AxiosStatic>('axios')

const handleLogout = () => {
  document.cookie = "quarkus-credential=; Max-Age=0"
  userStore.logout()
  router.push("/login")
}

if (!userInfo.userInfo.initialized) {
  const from = moment().add(0, 'month').startOf('month').format('YYYY-MM-DD')
  const to = moment().add(0, 'month').endOf('month').format('YYYY-MM-DD')

  axios.get(`/timeline/earning?from=${from}&to=${to}`).then(response => {
    if (response.status == 200) {
      const dataToStore = {
        initialized: true,
        fromTime: from,
        toTime: to,
        earnings: response.data
      } as UserInfo
      userInfo.storeUserInfo(dataToStore)
    }
  })

} else {
  console.log('UserInfo already initialized!')
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(userInfo).userInfo.initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(month)), 1))
        : _createCommentVNode("", true),
      (_unref(userInfo).userInfo.initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(earning)), 1))
        : _createCommentVNode("", true),
      (_unref(userInfo).userInfo.initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(formatWorkTime)(_unref(userInfo).allWorktimeSum)) + " [hod] ", 1))
        : _createCommentVNode("", true),
      (_unref(userStore).userDetail.userName)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("strong", null, _toDisplayString(_unref(userStore).userDetail.userName), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", { class: "align-items-center justify-content-center text-sm" }, [
        _createElementVNode("i", {
          class: "pi-sign-out pi text-cyan-200 cursor-pointer",
          onClick: handleLogout
        })
      ])
    ])
  ]))
}
}

})